import { setupLoggers } from "./log-wrapper"

export default () => {
  setupLoggers()
}
